import React, { useEffect, useState } from 'react';

type CaptainPick = {
  id: number;
  web_name: string;
  team_id: number;
  captaincy_score: number;
  breakdown?: {
    xGi: number;
    minutesProj: number;
    eafd: number;
    setPieceFactor: number;
  };
};

export default function Dashboard(): React.JSX.Element {
  const [picks, setPicks] = useState<CaptainPick[]>([]);
  const [updatedAt, setUpdatedAt] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const res = await fetch('/api/captaincy?gw=next', { signal: controller.signal });
        const data = await res.json();
        setPicks(data.picks ?? []);
        setUpdatedAt(data.fetched_at ?? '');
      } catch (e) {
      } finally {
        setLoading(false);
      }
    }
    load();
    return () => controller.abort();
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: '8px 0' }}>Next GW Overview</h2>
        {updatedAt && <span style={{ fontSize: 12, color: '#666' }}>Last updated: {new Date(updatedAt).toLocaleString()}</span>}
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <h3>Captaincy picks</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th align="left">Player</th>
                <th align="right">Score</th>
                <th align="right">xGI</th>
                <th align="right">Min</th>
                <th align="right">EAFD</th>
                <th align="right">Set piece</th>
              </tr>
            </thead>
            <tbody>
              {picks.map((p) => (
                <tr key={p.id}>
                  <td>{p.web_name}</td>
                  <td align="right">{p.captaincy_score.toFixed(2)}</td>
                  <td align="right">{p.breakdown ? p.breakdown.xGi.toFixed(2) : '-'}</td>
                  <td align="right">{p.breakdown ? Math.round(p.breakdown.minutesProj) : '-'}</td>
                  <td align="right">{p.breakdown ? p.breakdown.eafd.toFixed(2) : '-'}</td>
                  <td align="right">{p.breakdown ? (p.breakdown.setPieceFactor ? 'Yes' : 'No') : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


